import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";

interface UseGetDistributionRuleProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionRuleMethodStatusMatrix = async (communityId: string, year: string) =>
  await axiosAuth.get(`${DISTRIBUTION_RULE_API(communityId)}/year/${year}/method-status-matrix-new`);

const useGetDistributionRuleMethodStatusMatrix = ({
  queryParams,
  communityId,
  year,
}: UseGetDistributionRuleProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-rule-method-status-matrix", communityId, year],
    queryFn: () => getDistributionRuleMethodStatusMatrix(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionRuleMethodStatusMatrix;
